import { post } from '../utils/http/http'

const baseURL = '/Admin/UserLogin/'

export default {
  //登陆
  getToken: (payload: { username: string, password: string }) => post<{ token: string }>(`${baseURL}login`, payload),
}